<div class="image-wrap">
    <img [src]="aiImagePath" alt="AI Generated Price" />
</div>